var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-primary primary-field"},[_c('div',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),(_vm.item.is_error)?_c('i',{staticClass:"icon-fill_alert-circle"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }